// export const base_url = "https://dev-api.bennefin.com/";
// 
// export const base_url = "https://9rjkkh0g-4000.inc1.devtunnels.ms/";

// export const base_url =
//   window.location.hostname === "localhost"
//     ? "http://localhost:6574/"
//     : window.location.protocol + "//" + window.location.hostname + "/backend/";

//   export const base_url = "http://localhost:6574/backend/";
export const base_url = "https://prod.bennefin.com/backend/";

export const redirect_social_login_url =
  window.location.hostname === "localhost" ? "http://localhost:3000/" : "";
export const setUrl = () => {
  sessionStorage.setItem("prev_url", window.location.href);
};
export const ADMIN_ROLE = 1;

export const BUSINESS_ROLE = 2;
export const INVESTOR_ROLE = 3;
export const SUPER_ADMIN_ROLE = 5;
export const AUDITOR_ROLE = 4;
//service request types::
export const SERVICE_REQUEST_NEW_LOAN = 0;
export const SERVICE_REQUEST_EXTEND_TENURE = 1;
export const SERVICE_REQUEST_PRE_CLOSURE = 2;
export const SERVICE_REQUEST_PARTIAL_PRE_PAYMENT =  3;

export const STATUS_NEW = 1;
export const STATUS_IN_PROGRESS = 2;
export const STATUS_APPROVED = 3;
export const STATUS_REJECTED = 4;
export const STATUS_PROCESSED = 5;
export const STATUS_CLOSED = 6;
export const LOAN_REPAYMENT_BY_BUSINESS = 7;
export const LOAN_DELISTED = 8;
export const LOAN_TECHNICAL_CLOSURE = 9;
export const STATUS_PENDING_INVESTOR = 10; 
//loan currency types
export const LOAN_CURRENCY_TYPE_BHD = "BHD";
export const LOAN_CURRENCY_TYPE_USD = "USD";
export const CURRENCY_EXCHANGE_WITH_DINAR = 2.659;
//rakings
export const RATING_A = 1;
export const RATING_B = 2;
export const RATING_C = 3;
export const RATING_D = 4;

//crypto key
export const CRYPTO_SECRET_KEY = "8DQ1DABA8A4EE292A832E4C5BB7WC";

export const COMPLIANCE_NEW = 0;
export const COMPLIANCE_PENDING = 1;
export const COMPLIANCE_APPROVED = 2;
export const COMPLIANCE_REJECTED = 3;


//business history actions
export const ACTION_TYPE_BUSINESS_CREATION = 1;
export const ACTION_TYPE_KYC_DOCUMENTS = 2;
export const ACTION_TYPE_SERVICE_REQUEST = 3;
export const ACTION_TYPE_LOAN_REPAYMENT = 4;
export const ACTION_TYPE_APPROVED = 5;
export const ACTION_TYPE_PAYMENT_TO_BUSINESS = 6;


//Notifications
export const NOTIFICATION_TYPE_KYC_SUBMITTED = 21;
export const NOTIFICATION_TYPE_KYC_APPROVED = 22;
export const NOTIFICATION_TYPE_KYC_REJECTED = 23;
export const NOTIFICATION_ENTITY_BUSINESS = "Business";
export const NOTIFICATION_ENTITY_INVESTOR = "Investor";
export const NOTIFICATION_ENTITY_ADMIN = "Admin";
export const NOTIFICATION_ENTITY_ALLINVESTORS = "AllInvestors";
export const NOTIFICATION_TYPE_COMPLIANCE = 1;
export const NOTIFICATION_TYPE_RENEW_DOCUMENT = 2;
export const NOTIFICATION_TYPE_LOAN_REQUEST_NOTIFICATION = 3;
export const NOTIFICATION_TYPE_NEW_INVESTMENT_OPPORTUNITY = 4;
export const NOTIFICATION_TYPE_INTEREST_SUBMITTED = 5;
export const NOTIFICATION_TYPE_INTEREST_RECEIVED_FROM_INVESTOR = 6;
export const NOTIFICATION_TYPE_AWAITING_FOR_YOUR_RESPONSE = 7;
export const NOTIFICATION_TYPE_PAYMENT_PROCESSED = 8;
export const NOTIFICATION_TYPE_LOAN_CLOSED = 9;
export const NOTIFICATION_TYPE_EXTEND_TENURE_REQUEST = 10;
export const NOTIFICATION_TYPE_EXTEND_TENURE_APPROVED = 11;
export const NOTIFICATION_TYPE_EXTEND_TENURE_REJECTED = 12;
export const NOTIFICATION_TYPE_PRE_CLOSURE_REQUEST = 13;
export const NOTIFICATION_TYPE_PRE_CLOSURE_APPROVED = 14;
export const NOTIFICATION_TYPE_PRE_CLOSURE_REJECTED = 15;
export const NOTIFICATION_TYPE_BUSINESS_AGREED_TERMS = 16;
export const NOTIFICATION_TYPE_NEW_LOAN_REJECTED = 17;


export const COUNTRY = "bahrain";


export const NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REQUEST  = 18;
export const NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_APPROVED  = 19;
export const NOTIFICATION_TYPE_PARTIAL_PRE_PAYMENT_REJECTED  = 20;

export const NOTIFICATION_TYPE_LOAN_DELISTED = 24;
export const NOTIFICATION_TYPE_LOAN_TECHNICAL_CLOSURE = 25;

//kyc form investor
export const INVESTOR_TYPE_INDIVIDUAL= "individual";
export const INVESTOR_TYPE_COMPANY = "institution";

export const TURNSTILE_SITEKEY  = window.location.hostname==="localhost"?"0x4AAAAAAAZb1Qaxlo1ivPqg": "0x4AAAAAAAZLTlQv2_dact5K";
export const RANDOM_NUMBER = Math.random()

//save
export const SAVE_CONSTANT=1;
export const SUBMIT_CONSTANT=0;

export const LOAN_WAIVER_APPLIED = 11
